import ContentPartnersIndexComponent from '@views/content-partners/index';
import ContentPartnersShowComponent from '@views/content-partners/show';

export default [
  {
    path: '/content-partners',
    name: 'content-partners#index',
    component: ContentPartnersIndexComponent,
    meta: {
      masteryHeader: true,
      previewer: true,
    },
  },
  {
    path: '/content-partners/:contentPartnerId?',
    name: 'content-partners#show',
    component: ContentPartnersShowComponent,
    meta: {
      masteryHeader: true,
      previewer: true,
    },
  },
];